import { createSlice } from '@reduxjs/toolkit';

// Client state for the Internal jobs "Jobs" tab (filters / sort / search / page).
// Uses the new ("Filters" dropdown) filter framework: selected filter rows are
// stored as `feConfig`, the same shape the Jobs page uses.
const reducerName = 'internalJobs';
const initialState = {
  searchTerm: null,

  filters: {
    feConfig: [],
    isFilterApplied: false,
  },
  page: {
    number: 0,
    offset: 0,
    limit: 20,
  },
  sort: {
    label: 'Launched (Newest to oldest)',
    value: 'DESC',
    element: 'launch_at',
    order: 'DESC',
  },
};

const { reducer, actions: internalJobsActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    applySort: (state, { payload }) => {
      state.sort = payload;
    },

    // The new filter applies the full set of selected rows at once.
    setFiltersData: (state, { payload }) => {
      state.filters.feConfig = payload || [];
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = true;
    },

    applyPage: (state, { payload }) => {
      const { page } = payload;
      state.page.number = page;
      state.page.offset = state?.page?.number * state?.page?.limit;
    },

    clearFilter: (state, { payload }) => {
      const { key } = payload;
      state.filters.feConfig = (state.filters.feConfig || []).filter(
        (row) => row?.filter_by?.value !== key
      );
      state.page = { ...initialState.page };
      state.filters.isFilterApplied =
        state.filters.feConfig.length > 0 || !!state.searchTerm;
    },

    clearAllFilter: (state) => {
      state.filters = { ...initialState.filters, feConfig: [] };
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = false;
    },

    applySearch: (state, { payload }) => {
      state.searchTerm = payload?.searchTerm;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied =
        payload?.searchTerm?.length > 0 ||
        (state.filters.feConfig || []).length > 0;
    },

    // Rehydrate filters/sort/search from a persisted user preference (server
    // storage). Marks isFilterApplied so defaults don't overwrite saved state.
    restoreFilters: (state, { payload }) => {
      const { feConfig, searchTerm, sort } = payload || {};
      if (Array.isArray(feConfig)) state.filters.feConfig = feConfig;
      if (searchTerm !== undefined) state.searchTerm = searchTerm;
      if (sort) state.sort = sort;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied =
        (state.filters.feConfig || []).length > 0 || !!state.searchTerm;
    },
  },
});

export { internalJobsActions };
export default reducer;
